import { call, put, takeEvery } from "redux-saga/effects";
import * as PrivacySettingActions from "./privacysetting.actions";
import PrivacySettingAPI from "./privacysetting.api";
import { PrivacySettingActionTypes } from "./privacysetting.model";
import Swal from "sweetalert2";

export function* handleFetchPrivacySetting(action) {
    try {
        const response = yield call(
            PrivacySettingAPI.GetPrivacyByUser,
            action.payload
        );
        yield put(PrivacySettingActions.getPrivacySettingSuccess(response));
    } catch (e) {
        yield put(PrivacySettingActions.getPrivacySettingFailure(e));
    }
}

export function* handleOtherFetchPrivacySetting(action) {
    try {
        const response = yield call(
            PrivacySettingAPI.ListPrivacySetting,
            action.payload
        );
        yield put(
            PrivacySettingActions.getOtherPrivacySettingSuccess(response)
        );
    } catch (e) {
        yield put(PrivacySettingActions.getOtherPrivacySettingFailure(e));
    }
}

export function* handleUpdatePrivacySetting(action) {
    try {
        const response = yield call(
            PrivacySettingAPI.UpdatePrivacyByUser,
            action.payload
        );
        yield put(PrivacySettingActions.updatePrivacySettingSuccess(response));
        Swal.fire({
            title: "Settings",
            text: "Your new setting is updated",
            icon: "success",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "green",
            showConfirmButton: false,
            cancelButtonText: "Close",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        });
    } catch (e) {
        yield put(PrivacySettingActions.updatePrivacySettingFailure(e));
    }
}

export function* PrivacySettingSaga() {
    yield takeEvery(
        PrivacySettingActionTypes.FETCH_PRIVACY_SETTING_REQUEST,
        handleFetchPrivacySetting
    );
    yield takeEvery(
        PrivacySettingActionTypes.UPDATE_PRIVACY_SETTING_REQUEST,
        handleUpdatePrivacySetting
    );
    yield takeEvery(
        PrivacySettingActionTypes.FETCH_OTHER_PRIVACY_SETTING_REQUEST,
        handleOtherFetchPrivacySetting
    );
}
